module.exports = __webpack_public_path__ + "img/task.a59fadd4.svg";